<template>
  <v-dialog v-model="show" max-width="700px">
    <v-card>
      <v-card-title>
        <span class="headline" v-if="isEdited">{{
          $t("clients.edit_client")
        }}</span>
        <span class="headline" v-else>{{ $t("clients.add_client") }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="client.internal_id"
                  :label="$t('clients.internal_id_form')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="client.name"
                  :label="$t('clients.name')"
                  :rules="rules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="client.surname"
                  :label="$t('clients.surname')"
                  :rules="rules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  :items="companies"
                  item-text="name"
                  item-value="id"
                  v-model="client.company_id"
                  :label="$t('clients.company_id')"
                  :rules="rules"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  :items="sections"
                  item-text="name"
                  item-value="id"
                  v-model="client.section_id"
                  :label="$t('clients.section_id')"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-menu
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="formattedStartDate"
                        v-on="on"
                        clearable
                        :label="$t('clients.start_date')"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="client.start_date"
                      @input="startDateMenu = false"
                      :locale="$i18n.locale"
                    ></v-date-picker>
                  </v-menu>
              </v-col>
              <v-col cols="12" sm="5">
                <v-text-field
                  v-model="client.managers_name"
                  :label="$t('clients.managers_name')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="client.delivery_note"
                  :label="$t('clients.delivery_note')"
                  :rows="4"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="client.delivery_note_2"
                  :label="$t('clients.delivery_note_2')"
                  :rows="4"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="5">
                <v-switch
                  color="green"
                  v-model="client.is_active"
                  :label="
                    client.is_active
                      ? $t('general.active')
                      : $t('general.not_active')
                  "
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="submit">{{
          $t("general.save")
        }}</v-btn>
        <v-btn @click.stop="show = false">{{ $t("general.cancel") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  name: "ClientForm",
  props: {
    form: {
      type: Object,
    },
    client: Object,
    visible: Boolean,
    isEdited: Boolean,
    variables: Object
  },

  data() {
    return {
      startDateMenu: false,
      companies: [],
      divisions: [],
      sections: [],
      checkedDefault: true,
      valid: true,
      showEye: false,
      rules: [(value) => !!value || this.$t("general.required")],
    };
  },

  watch: {
    show(val) {
      !val && this.$refs.form.reset();
    },
  },
  computed: {
    formattedStartDate: {
      get() {
        return this.client.start_date != null &&
          this.client.start_date != ""
            ? moment(this.client.start_date).format("DD.MM.YYYY")
            : this.client.start_date;
      },
      set(value) {
        this.client.start_date = value;
      },
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  created() {
    this.getCompanies();
    this.getDivisions();
    this.getSections();
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.isEdited) {
          await axios
            .put(`/api/updateClient/${this.client.id}`, this.client, {
              headers: {
                Authorization:
                  "Bearer " + this.$store.state.tokenData.user.access_token,
              },
            })
            .then((response) => {
              if (response.data.isError) {
                this.$emit("snackMessage", response.data.message, "warning");
              } else {
                // response.data.roleName = response.data.role == "admin" ? "Admin": "Uživatel";
                this.$emit("updateClient", response.data);
                this.$emit("snackMessage", "clients.client_saved", "success");
                this.$emit("close");
              }
            })
            .catch((error) => {
              console.log(error);
              this.$emit("snackMessage", "general.error", "error");
            });
        } else {
          await axios
            .post(`/api/storeClient`, this.client, {
              headers: {
                Authorization:
                  "Bearer " + this.$store.state.tokenData.user.access_token,
              },
            })
            .then((response) => {
              if (response.data.isError) {
                this.$emit("snackMessage", response.data.message, "warning");
              } else {
                this.$emit("addClient", response.data);
                this.$emit("snackMessage", "clients.client_added", "success");
                this.$emit("close");
              }
            })
            .catch((error) => {
              console.log(error);
              this.$emit("snackMessage", "general.error", "error");
            });
        }
      }
    },
    async getCompanies() {
      await axios
        .get("/api/companyList", {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.companies = response.data;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    async getDivisions() {
      await axios
        .get("/api/divisionList", {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.divisions = response.data;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    async getSections() {
      await axios
        .get("/api/sectionList", {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.sections = response.data;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
  },
};
</script>
